<template>
  <button
    v-wave
    class="template-card flex-none w-[160px] p-3.5 rounded-md border flex flex-col gap-1.5 relative text-right cursor-pointer transition-colors"
    :class="template.active
      ? ' border-[#ddd8fc] hover:border-primary-300'
      : 'bg-gray-50 border-gray-200 opacity-75'"
    @click="$emit('click')"
  >
    <span
      v-if="template.active"
      class="absolute top-2.5 left-2.5 inline-flex items-center gap-1 text-[10px] font-medium px-1.5 py-0.5 rounded bg-green-100 text-green-700"
    >
      <span class="w-1 h-1 rounded-full bg-green-600" />
      באתר
    </span>
    <span
      v-else
      class="absolute top-2.5 left-2.5 text-[10px] font-medium px-1.5 py-0.5 rounded bg-gray-100 text-gray-500"
    >
      טיוטה
    </span>

    <div class="w-8 h-8 rounded-full flex items-center justify-center bg-gradient-to-br from-[#c4b0ee] to-[#a691f4]">
      <i class="pi pi-ticket text-sm text-white" />
    </div>

    <div class="text-[11px] text-gray-500 font-medium truncate w-full">{{ subtitle }}</div>
    <div class="text-[22px] font-semibold text-gray-900 leading-none">{{ valueLabel }}</div>
  </button>
</template>

<script setup lang="ts">
import { computed, PropType } from 'vue';
import { IVoucherTemplate, VoucherTypes } from '@torim-app/types';
import { useAdminStore } from '@app/stores';

const adminStore = useAdminStore();

const props = defineProps({
  template: {
    type: Object as PropType<IVoucherTemplate>,
    required: true
  }
});

defineEmits<{ (e: 'click'): void }>();

// Services covered by a "service" voucher — it covers their full cost.
const includedServices = computed(() => {
  const all = adminStore.businessSiteData?.services ?? [];
  return all.filter(s => props.template.serviceIds?.includes(s.id));
});

const subtitle = computed(() => {
  if (props.template.voucherType === VoucherTypes.AMOUNT) return 'שובר מתנה';
  const names = includedServices.value.map(s => s.name).join(', ');
  return names || 'שובר טיפול';
});

const valueLabel = computed(() => {
  if (props.template.voucherType === VoucherTypes.AMOUNT) return `₪${props.template.amount ?? 0}`;
  // A service voucher covers the full price of the included services.
  const total = includedServices.value.reduce((sum, s) => sum + (s.price ?? 0), 0);
  return `₪${total}`;
});
</script>

<style scoped>
.template-card {
  scroll-snap-align: start;
}
</style>
